'use client';

import { fetchQuestionDetail } from '@/apis/help/help.api';
import RichComponent from '@/components/product/richComponent';
import React, { memo, useEffect, useState } from 'react';
import UKPageNothing from '@/components/UKPageNothing';
import UKLoadingIcon, { CIRCLE_COLOR_MAP } from '@/components/UKLoadingIcon';

import styles from './index.module.scss';

interface OpcDetailProps {
  scene?: string;
  title?: string;
  desc?: string;
}

interface OpcData {
  facadeName?: string;
  facadeContent?: string;
}

const OpcDetail: React.FC<OpcDetailProps> = memo(({ scene, title, desc }) => {
  const [data, setData] = useState<OpcData>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { facadeName, facadeContent } = data || {};

  useEffect(() => {
    const initData = async () => {
      setIsLoading(true);
      const { data, code } = await fetchQuestionDetail({ scene });
      setIsLoading(false);
      if (code === '200') {
        setData(data);
      }
    };
    initData();
  }, [scene]);

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <UKLoadingIcon type={CIRCLE_COLOR_MAP.BLACK} />
      </div>
    );
  }

  return (
    <div className={styles.opcDetail}>
      <h1 className={styles.opcDetailTitle}>{title || facadeName}</h1>
      {desc || facadeContent ? (
        <RichComponent
          style={{ fontSize: 14 }}
          data={desc || facadeContent || ''}
          isShadowDom={false}
        />
      ) : (
        <UKPageNothing />
      )}
    </div>
  );
});
OpcDetail.displayName = 'OpcDetail';
export default OpcDetail;
